var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipDeleteDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_383_5121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_383_5121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73329 11.0834L2.91663 10.2667L6.18329 7.00008L2.91663 3.73341L3.73329 2.91675L6.99996 6.18342L10.2666 2.91675L11.0833 3.73341L7.81663 7.00008L11.0833 10.2667L10.2666 11.0834L6.99996 7.81675L3.73329 11.0834Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipDeleteDark);
export default __webpack_public_path__ + "static/media/ic-chip-delete-dark.8d7fecf94dcdf2c2f77c074b1291301a.svg";
export { ForwardRef as ReactComponent };